import { george, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { FeatureRoutes } from "components/app/AppRoutes";
import { useEffect } from "react";
import { pushRoute } from "stores/RouterFunctions";
import { amountToCurrencyString, ZERO_AMOUNT } from "types/amount";
import { isBankCard, isCreditCard, supportsUpgrade } from "types/card";
import { FEETYPE_REISSUE_CARD } from "types/fee";
import { ReissueCardRoutes } from "./ReissueCardRoutes";
import { ReissueCardStore } from "./ReissueCardStore";

type IProps = RouteComponentProps<{}> & {
    store: ReissueCardStore,
    checkForUpgrade?: boolean
};

export const ReissueCardConfiguration = observer((props: IProps) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const card = props.store.cardStore.card;
    useEffect(() => {
        if (props.checkForUpgrade && card && supportsUpgrade(card)) {
            document.title = ui.__("reissueCardUpgrade.document.title");
            pushRoute(FeatureRoutes.REISSUE_CARD_UPGRADE);
        }
    }, [props.checkForUpgrade, card]);

    const onSubmit = async () => {
        try {
            await props.store.reissueCard();
            pushRoute(ReissueCardRoutes.SIGNING);
        } catch (error) {
            pushRoute("/error");
        }
    };

    const buttonIsLoading = props.store.isLoading || props.store.isLoadingReissue;
    const fee = props.store.feesStore.getFeeForType(FEETYPE_REISSUE_CARD);
    const feeString = amountToCurrencyString(fee ? fee.fee : ZERO_AMOUNT);

    return (
        <george.Background>
            <george.PageWithActionButton>
                {!props.store.isLoading && props.store.cardStore && props.store.cardStore.card &&
                    <george.Card>
                        <george.CardSectionTitle title={ui.__("reissueCard.document.title")} />
                        <george.CardSectionContent>
                            <pr.P_14_CONTENT>
                                {ui.__("reissueCard.info", {
                                    product: props.store.cardStore.card.productI18N,
                                    number: props.store.cardStore.card.number,
                                    fee: feeString
                                })}
                                {isBankCard(props.store.cardStore.card) && <>
                                    <br /><br />
                                    {ui.__("reissueCard.info.bankCard")}
                                </>}
                            </pr.P_14_CONTENT>

                            {isCreditCard(props.store.cardStore.card) &&
                                <pr.P_14_CONTENT><br />{ui.__("reissueCard.warning.creditCard")}</pr.P_14_CONTENT>
                            }

                            <george.Fees label={ui.__("common.fees")} value={feeString} />
                        </george.CardSectionContent>
                    </george.Card>
                }

                <george.LoadingIndicator isLoading={props.store.isLoading} height={ui.windowHeight} />
                <george.ActionButton
                    messageId="button.continue"
                    disableButton={buttonIsLoading}
                    isLoading={buttonIsLoading}
                    onClick={onSubmit}
                />
            </george.PageWithActionButton>
        </george.Background>
    );
});




// WEBPACK FOOTER //
// ./src/components/reissueCard/ReissueCardConfiguration.tsx